(ns manage.privacy-modal.db
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :modal.privacy/init
  (fn [_ _]
    {:forward-events [{:register ::modal-open
                       :events #{:resource.user/get-me-success}
                       :dispatch-to [:modal.privacy/open]}]}))

(rf/reg-event-fx :modal.privacy/open
  [(rf/inject-cofx :sub :resource.user/me)]
  (fn [{{:keys [privacySettingsAccepted]} :resource.user/me} _]
    {:fx [(when (nil? privacySettingsAccepted)
            [:dispatch [:modal/open {:id :privacy-modal}]])
          [:forward-events [{:unregister ::modal-open}]]]}))

(rf/reg-event-fx :modal.privacy/submit
  (fn [_ [_ accepted?]]
    {:fx [[:forward-events [{:register ::submit-success
                             :events #{:resource.user/patch-me-success}
                             :dispatch-to [:modal.privacy/submit-success]}
                            {:register ::submit-failure
                             :events #{:resource.user/patch-me-failure}
                             :dispatch-to [:modal.privacy/submit-failure]}]]
          [:dispatch [:loader/open]]
          [:dispatch [:resource.user/patch-me {:privacySettingsAccepted accepted?}]]]}))

(rf/reg-event-fx :modal.privacy/submit-success
  (fn [_ _]
    {:fx [[:forward-events [{:unregister ::submit-success}
                            {:unregister ::submit-failure}]]
          [:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name "Privacy Modal"
                       :type :success
                       :message "Your preference is saved"}]]
          [:dispatch [:modal/close]]]}))

(rf/reg-event-fx :modal.privacy/submit-failure
  (fn [_ [event [_ response]]]
    {:fx [[:forward-events [{:unregister ::submit-success}
                            {:unregister ::submit-failure}]]
          [:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name "Privacy Modal"
                       :type :error
                       :event event
                       :response response}]]]}))

(defn start []
  (rf/dispatch [:modal.privacy/init]))
